import _ from "lodash";
import ReceiptService from "../../actions/receipt/receiptsService";
const receiptService = new ReceiptService();

const initailState = {
  receipt: {},
  newReceipt: {
    items: [],
  },
  changeReceipt: {
    changeItems: [],
  },
  changeReceiptItems: [],
  rolePermissions: [],

  createReceipt: {},
  changeReceiptBasicInformation: {},
  // wmTransactionDatabase:{},
  wmTransactionDatabase: "",
  treeViewVisibleUrls: [], // Store visible URLs from tree view (as array for Redux compatibility)
  reportMenu: null, // Raw DB report menu shared by the sidebar; null until loaded
};

const clickOnCheckboxForId = (state = initailState, action) => {
  switch (action.type) {
    case "ON_Change_Database":
      return {
        ...state,
        wmTransactionDatabase: action.payload,
      };
    case "Click_Checkbox":
      return {
        ...state,
        receipt: [action.payload],
      };
    case "ON_SELECTED_QUANTITY_ITEM": {
      let itemObject = action.payload.key;
      itemObject.quantityorder = action.payload.newData.quantityorder;
      let itemIndex = state.newReceipt.items.findIndex(
        (itemObj) => itemObj.rowid === itemObject.rowid
      );

      if (itemObject.quantityorder === null) {
        if (itemIndex > -1) {
          var deletedItem = [...state.newReceipt.items.splice(itemIndex, 1)];
          console.log(deletedItem, "deleted item for create receipt");
          return {
            ...state,
            newReceipt: {
              items: [...state.newReceipt.items],
            },
          };
        }
      }
      if (itemIndex > -1) {
        var deleteItem = [...state.newReceipt.items.splice(itemIndex, 1)];
        console.log(deleteItem, "deleted item for create receipt");
      }

      let newArray = new Array();
      newArray.push(itemObject);
      return {
        ...state,
        newReceipt: {
          items: [...state.newReceipt.items, ...newArray],
        },
      };
    }

    case "ON_ChangeReceipt_SELECTED_QUANTITY_ITEM": {
      let changeItemObject = action.payload.key;
      changeItemObject.quantityorder = action.payload.newData.quantityorder;
      let indexOfItem = state.changeReceiptItems.findIndex(
        (changeItemObj) => changeItemObj.rowid === changeItemObject.rowid
      );

      if (
        changeItemObject.quantityorder === 0 ||
        changeItemObject.quantityorder === null
      ) {
        if (indexOfItem > -1) {
          var res = receiptService
            .deleteReceiptDetailItem({
              rItemRowId: changeItemObject.rowid,
              transHeaderId: action.payload.transHeaderId,
              dbName: action.payload.dbName,
              access_token: action.payload.access_token,
            })
            .then((res) => {
              console.log(res, "res");
            })
            .catch((err) => {
              console.log(err, "error");
            });
          var items = [...state.changeReceiptItems.splice(indexOfItem, 1)];
          console.log(items);
          return {
            ...state,
            changeReceiptItems: [...state.changeReceiptItems],
          };
        }
      }
      if (indexOfItem > -1) {
        var items = [...state.changeReceiptItems.splice(indexOfItem, 1)];
        console.log(items);
      }

      let newArray = new Array();
      newArray.push(changeItemObject);

      return {
        ...state,
        changeReceiptItems: [...state.changeReceiptItems, ...newArray],
      };
    }

    case "Create_New_Receipt": {
      return {
        ...state,
        createReceipt: [action.payload],
      };
    }
    case "Fetch_Roles_Permissions": {
      return {
        ...state,
        rolePermissions: action.payload,
      };
    }

    case "Change_Receipt": {
      return {
        ...state,
        changeReceiptBasicInformation: [action.payload],
      };
    }

    case "Reset_Items": {
      return {
        ...state,
        newReceipt: {
          items: [...action.payload],
        },
      };
    }

    case "Change_New_Receipt_Items": {
      console.log("=============", state, "==========", action);

      return {
        ...state,
        changeReceiptItems: [...state.changeReceiptItems, ...action.payload],
      };
    }

    case "Reset_Change_Receipt_Items": {
      return {
        ...state,
        changeReceiptItems: [...action.payload],
      };
    }

    case "SET_TREEVIEW_VISIBLE_URLS": {
      // Convert Set to array if needed (Redux doesn't support Set)
      const urlsArray = action.payload instanceof Set ? Array.from(action.payload) : action.payload;
      return {
        ...state,
        treeViewVisibleUrls: urlsArray || [],
      };
    }

    case "SET_REPORT_MENU": {
      return {
        ...state,
        reportMenu: action.payload || [],
      };
    }

    default:
      return state;
  }
};
export default clickOnCheckboxForId;
